import { createFileRoute } from "@tanstack/react-router";
import { CampaignDetail } from "@/components/campaigns/CampaignDetail";
import { useSession } from "@/hooks/use-session";

export const Route = createFileRoute("/_app/_/campaigns/$goalId")({
	component: CampaignDetailPage,
});

function CampaignDetailPage() {
	const session = useSession();
	const campaignId = session.campaign?.id;
	const { goalId } = Route.useParams();
	const goalIdNum = Number(goalId);
	if (!campaignId) {
		return (
			<div className="mx-auto max-w-4xl p-6">
				<p className="text-muted-foreground">
					No campaign found. Please complete onboarding first.
				</p>
			</div>
		);
	}
	if (!Number.isFinite(goalIdNum) || goalIdNum <= 0) {
		return (
			<div className="mx-auto max-w-4xl p-6">
				<p className="text-muted-foreground">Campaign not found.</p>
			</div>
		);
	}
	return <CampaignDetail campaignId={campaignId} goalId={goalIdNum} />;
}
